import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
    }

    copy() {
        const accountIds = this.accounts.map(({id}) => id);

        this.isSaving = true;
        this.AccountsResource
            .copyUsersToGroup(this.companyId, this.st.selectedIds, accountIds)
            .then(() => this.$state.go('^'))
            .then(() => this.Alert('success', 'company.user-directories.directory-groups.all-accounts.copy.copied'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/copy/copy-accounts-to-groups.controller.js